import React, { Fragment, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { NetworkStatus } from '@apollo/client';
import { useTranslation } from 'react-i18next';

import { GQLParty, GQLPieceAsset } from '@jewelutions/core-crm-server-api-client-domain';

import { userLanguage } from '../../../../core/AuthContext';
import { JwlTable, LoadingSpinner, ErrorComponent } from '../../../../components';

import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';
import { ProducerNavigation } from '../../navigation/ProducerNavigation';

interface IProps {
  party: GQLParty;
}

const PiecesList: React.FC<IProps> = ({ party }: IProps) => {
  const history = useHistory();
  const [errorComponentState, setErrorComponentState] = useState(false);
  const { t: translate } = useTranslation();

  const { data, loading, error, networkStatus, refetch } = GQLOperationBuilder.piece.getPiecesByProducer({
    producerPartyId: party.id
  });

  const reloadData = () => {
    refetch().then();
  };

  if (loading || networkStatus === NetworkStatus.refetch) return <LoadingSpinner />;

  if (error && !errorComponentState)
    return (
      <ErrorComponent
        close={setErrorComponentState}
        details={error?.stack}
        callback={reloadData}
        message={error.message}
      />
    );

  const getPiecesRows = () => {
    return GQLOperationBuilder.piece.pieceAssetArrayFromResponse(data).map((piece: GQLPieceAsset) => {
      return {
        id: piece.id,
        cells: [
          piece.piece.title[userLanguage],
          piece.piece.description[userLanguage],
          piece.piece.geometryType
        ]
      };
    });
  };

  const navigateToPieceDetails = (pieceId: string) => {
    history.push(ProducerNavigation.pieceDetails.pathFromParams({ pieceId: pieceId }));
  };

  return (
    <Fragment>
      <JwlTable
        title="Producer pieces list"
        description={`The list of piece geometries available to the producer ${party.name}`}
        columns={['Name', 'Description', 'Geometry']}
        rows={getPiecesRows()}
        onTableRowClick={navigateToPieceDetails}
      />
    </Fragment>
  );
};

export default PiecesList;
